module.exports = function() {
  return new Worker("/" + "unzip_imgs.worker.5af820acac3c223adcc3.js");
};